import React, { FC } from 'react';
import { Mixins, Text, TextProps } from '@openfin/ui-library';
import styled from 'styled-components';
import { useTooltip } from '../../hooks/useTooltip';

interface Props extends Omit<TextProps, 'children'> {
  children?: string;
}

/**
 * A single line of Text that will overflow will ellipsis. When overflown mousing over the text will display a tooltip with the text content.
 */
export const SingleLine: FC<Props> = ({ children, ...rest }) => (
  <Element ref={useTooltip(children)} {...rest}>
    {children}
  </Element>
);

const Element = styled(Text)`
  white-space: nowrap;
  ${Mixins.textOverflow};
`;
